<script setup lang="ts">
defineProps<{
  title: string;
  text?: string | null;
  link_url?: string | null;
  link_label?: string | null;
}>();
</script>

<template>
  <section class="block-cta">
    <h3 class="block-cta__title">{{ title }}</h3>
    <p v-if="text" class="block-cta__text">{{ text }}</p>
    <a
      v-if="link_url"
      :href="link_url"
      class="block-cta__link"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ link_label || link_url }}
    </a>
  </section>

</template>

<style scoped>
.block-cta {
  margin: 1.5em 0;
  padding: 1.25em;
  background: var(--color-cta-bg, #f0f4f8);
  border-radius: 6px;
}
.block-cta__title {
  margin: 0 0 0.5em;
  font-size: 1.1em;
  font-weight: 600;
}
.block-cta__text {
  margin: 0 0 0.75em;
  font-size: 0.95em;
  line-height: 1.5;
}
.block-cta__link {
  display: inline-block;
  color: var(--color-link, #0066cc);
  font-weight: 500;
}
.block-cta__link:hover {
  text-decoration: underline;
}
</style>
